/**
 * Controller para a diretiva de edição de contatos de cliente. 
 */

angular.module("avlib").controller(
		"contactEditorController", 
		["$scope", "$log", "addressService", "electronicAddressService", 
				"electronicAddressConst", "phoneCodeConst",
		function ContactEditorController(
				$scope, $log, addressService, electronicAddressService, 
				electronicAddressConst, phoneCodeConst) {
	/**
	 * Relação de códigos telefônicos internacionais.
	 */
	$scope.internationalPhoneCodes = [];
	
	/**
	 * Relação de tipos de contato eletrônico.
	 */
	$scope.contactTypes = [];
	
	/**
	 * Modelo de dados para as combos.
	 */
	$scope.comboModel = {
		// O tipo de contato que está selecionado na combo.
		selectedContactType: null
	};
	
	/**
	 * Constrói um novo objeto do tipo Phone.
	 * 
	 * @param isMobile indica se o telefone é celular
	 */
	var Phone = function(isMobile){
		this.country_code = phoneCodeConst.BRAZIL;
		this.whatsapp = false;
		this.mobile = isMobile;
	};
	
	/**
	 * Obtém todos os tipos de contatos eletrônicos disponíveis na base de dados.
	 */
	var loadContactTypes = function(){
		$log.debug("Controlador solicitando dados de tipos de endereço eletrônico.");
		electronicAddressService.getElectronicAddressTypes().then(function(response){
			$scope.contactTypes = [{id: electronicAddressConst.MOBILE_PHONE_ID, name: 'Telefone celular'}, {id: electronicAddressConst.LANDLINE_ID, name: 'Telefone fixo'}];
			$scope.contactTypes = $scope.contactTypes.concat(response.data);
			$log.debug("Dados de tipos de endereço eletrônico carregados com sucesso.");
		}, function(response){
			$log.debug("Falha ao carregar dados de tipos de endereço eletrônico: "+response.status+" "+response.statusText);
		});
	};
	
	/**
	 * Obtém todos os códigos telefônicos internacionais disponíveis na base de dados.
	 */
	var getInternationalPhoneCodes = function(){
		$log.debug("Controlador solicitando dados dos códigos telefônicos internacionais");
		addressService.getInternationalPhoneCodes().then(function(response){
			$scope.internationalPhoneCodes = response.data;
			$log.debug("Dados de códigos telefônicos internacionais carregados com sucesso.");
		}, function(response){
			$log.debug("Falha ao carregar dados de códigos telefônicos internacionais: "+response.status+" "+response.statusText);
		});
	};	

	/**
	 * Obtém a expressão regular que será utilizada por default para validar endereços eletrônicos.
	 */
	var _getDefaultRegex = function(){
		return '[a-zA-Z\\d_-]+';
	};
	
	/*
	 * Funções disponíveis no $scope 
	 */
	
	$scope.$watch("contactForm.$valid", function(newValue, oldValue){
		if ($scope.callbacks){
			$scope.callbacks.setValid(newValue);
		}
	});	
	
	/**
	 * Obtém a expressão regular que será utilizada para validar o formato do endereço de e-mail.
	 */
	// https://www.wired.com/2008/08/four_regular_expressions_to_check_email_addresses/
	// Ver tarefa Mantis #17
	$scope.getEmailRegex = function(){
		return '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}';
	};
	
	/**
	 * Obtém a expressão regular que será utilizada para validar o formato do endereço de Facebook.
	 */
	$scope.getFacebookRegex = function(){
		return '[a-zA-Z\\d.]{5,}';
	};

	/**
	 * Obtém a expressão regular que será utilizada para validar o formato do endereço de Linkedin.
	 */
	$scope.getLinkedinRegex = function(){
		return _getDefaultRegex();
	};

	/**
	 * Obtém a expressão regular que será utilizada para validar o formato do endereço do Instagram.
	 */
	$scope.getInstagramRegex = function(){
		return _getDefaultRegex();
	};
	
	/**
	 * Obtém a expressão regular que será utilizada para validar o formato do endereço do Twitter.
	 */
	$scope.getTwitterRegex = function(){
		return _getDefaultRegex();
	};
	
	/**
	 * Obtém a expressão regular que será utilizada para validar o formato do endereço de home page.
	 */
	$scope.getHomepageRegex = function(){
		return '(http(s)?:\\/\\/.)?(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&\\/=]*)';
	};

	$scope.isCompactMode = function(){
		return $scope.mode == "compact";
	};
	
	/**
	 * Indica se um determinado identificador de tipo de contato se refere a um número telefônico.
	 */
	$scope.isPhoneNumber = function(contactTypeId){
		return contactTypeId === electronicAddressConst.MOBILE_PHONE_ID || contactTypeId === electronicAddressConst.LANDLINE_ID;
	};
	
	/**
	 * Indica se um determinado identificador de tipo de contato se refere a um número de telefone celular.
	 */
	$scope.isMobilePhoneNumber = function(contactTypeId){
		return contactTypeId === electronicAddressConst.MOBILE_PHONE_ID;
	};
	
	/**
	 * Indica se um determinado identificador de tipo de contato se refere a um endereço de e-mail.
	 */
	$scope.isEmail = function(contactTypeId){
		return contactTypeId === electronicAddressConst.EMAIL_ID;
	};
	
	/**
	 * Indica se um determinado identificador de tipo de contato se refere a um endereço de Facebook.
	 */
	$scope.isFacebook = function(contactTypeId){
		return contactTypeId === electronicAddressConst.FACEBOOK_ID;
	};
	
	/**
	 * Indica se um determinado identificador de tipo de contato se refere a um endereço do Linkedin.
	 */
	$scope.isLinkedin = function(contactTypeId){
		return contactTypeId === electronicAddressConst.LINKEDIN_ID;
	};
	
	/**
	 * Indica se um determinado identificador de tipo de contato se refere a um endereço do Instagram.
	 */
	$scope.isInstagram = function(contactTypeId){
		return contactTypeId === electronicAddressConst.INSTAGRAM_ID;
	};
	
	/**
	 * Indica se um determinado identificador de tipo de contato se refere a um endereço do Twitter.
	 */
	$scope.isTwitter = function(contactTypeId){
		return contactTypeId === electronicAddressConst.TWITTER_ID;
	};
	
	/**
	 * Indica se um determinado identificador de tipo de contato se refere a um endereço de home page.
	 */
	$scope.isHomepage = function(contactTypeId){
		return contactTypeId === electronicAddressConst.HOMEPAGE_ID;
	};
	
	/**
	 * Indica se o botão de adicionar novo contato deve estar habilitado. 
	 */
	$scope.isAddAddressButtonEnabled = function(){
		return $scope.comboModel.selectedContactType != null;
	};
	
	/*
	 * Listeners dos componentes da view
	 */
	
	/**
	 * Listener de click para o botão de adicionar contato.
	 */
	$scope.addElectronicAddressButtonClicked = function(){
		$log.debug("Usuário solicitou adição de contato do tipo "+$scope.comboModel.selectedContactType.name);
		
		var contactTypeId = $scope.comboModel.selectedContactType.id;
		if ($scope.isPhoneNumber(contactTypeId)){
			var newPhone = new Phone($scope.isMobilePhoneNumber(contactTypeId));
			$scope.phones.push(newPhone);
		}else{
			var newEaddress = new ElectronicAddress($scope.comboModel.selectedContactType);
			$scope.eAddresses.push(newEaddress);
		}
		
		$scope.comboModel.selectedContactType = null;
	};
	
	/**
	 * Listener de click para o botão de remover telefone.
	 */
	$scope.deletePhoneButtonClicked = function(phone){
		$log.debug("Usuário solicitou a eliminação do contato do tipo telefone.");
		var index = $scope.phones.indexOf(phone);
		var deletedPhone = $scope.phones.splice(index, 1)[0];
		/*
		 * Se foi definida uma lista de identificadores de telefone excluídos e
		 * se o telefone excluído já possuía um identificador de banco de dados,
		 * armazenamos este identificados na lista de excluídos:
		 */
		if ($scope.deletedPhones && deletedPhone.id){
			$scope.deletedPhones.push(deletedPhone.id);
		}
	};

	/**
	 * Listener de click para o botão de remover endereço eletrônico.
	 */
	$scope.deleteEAddressButtonClicked = function(eAddress){
		$log.debug("Usuário solicitou a eliminação do contato do tipo "+eAddress.type.name);
		var index = $scope.eAddresses.indexOf(eAddress);
		var deletedAddress = $scope.eAddresses.splice(index, 1)[0];
		/*
		 * Se foi definida uma lista de identificadores de endereços excluídos e
		 * se o endereço excluído já possuía um identificador de banco de dados,
		 * armazenamos este identificados na lista de excluídos:
		 */
		if ($scope.deletedAddresses && deletedAddress.id){
			$scope.deletedAddresses.push(deletedAddress.id);
		}
	};

	/*
	 * Carregando os dados necessários para o funcionamento do controlador.
	 */
	loadContactTypes();
	getInternationalPhoneCodes();
}]);
